module.exports = __webpack_public_path__ + "static/media/fetchingContent.7f1bb455.png";